// extracted by mini-css-extract-plugin
export default {"message":"styles_message_czNUe","iconContainer":"styles_icon-container_v81A6","compact":"styles_compact_LYuxP","vertical":"styles_vertical_M3wka","actions":"styles_actions_jiVSh"};